import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { ConfigurationService } from '../configuration.service';
import { EmailType, SendType, TemplateType } from '../dashboard-config.model';
import { SearchEmailConfigComponent } from './search-email-config/search-email-config.component';

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.scss']
})
export class EmailConfigurationComponent implements OnInit {
   destroyemail$: Subject<boolean> = new Subject<boolean>();
  public selectEmailObj: any = {};
  selectedEmailId: string;
  emailForm: FormGroup;
  SavingPayLoad: any;
  emailtypeList: EmailType[] = [];
  sendtypeList: SendType[] = [];
  temptypeList: TemplateType[] = [];
  emailType: FormControl;
  filteredEmailtypeArray: Observable<any[]>;
  sendtype: FormControl;
  filteredSendtypeArray: Observable<any[]>;
  filteredtemptypeArray: Observable<TemplateType[]>;
  temptype: FormControl;
  selectfile: any;
  selectedfileName: string = '';
  fileType: any;
  file: any;
  browsebtn: boolean = true;
  savetxtbtn: boolean = true;
  htmlbtn: boolean = true;
  selectedEmaildata: any;
  MsgeTemp: string;
  tempTypeName: any;
  typename: any;
  emailTypeName: any;
  emailData: any;
  user_validated = "";
  sendTypeName: any;
  constructor(public dialog: MatDialog, public configService: ConfigurationService, private _fb: FormBuilder,) { }

  ngOnInit(): void {
    this.loadEmailConfigForm();
    this.emailTypelist();
    this.sendTypelist();
    this.templateTypelist();
    this.emailTypeControll();
    this.sendtypeControll();
    this.temptypeControll();
    this.allEmailType();
    this.emailTypeName = '';
    this.sendTypeName = '';

  }

  allEmailType() {
    this.configService.emailConfigType(0).pipe(takeUntil(this.destroyemail$)).subscribe(data => {
      this.emailData = data
    });
  }
  emailTypelist() {
    this.configService.getEmailType().pipe(takeUntil(this.destroyemail$)).subscribe(data => {
      this.emailtypeList = data;
      this.emailTypeControll();
    });
  }
  sendTypelist() {
    this.configService.getSendType().pipe(takeUntil(this.destroyemail$)).subscribe(data => {
      this.sendtypeList = data;
      this.sendtypeControll();
    });
  }
  templateTypelist() {
    this.configService.getTemplateType().pipe(takeUntil(this.destroyemail$)).subscribe(data => {
      this.temptypeList = data;
      this.temptypeControll();
    });
  }

  emailTypeControll() {
    this.emailType = new FormControl();
    this.filteredEmailtypeArray = this.emailType.valueChanges
      .pipe(startWith(''),
        map(item => item ? this.filterEtypefunction(item) : this.emailtypeList.slice())
      );
  }

  filterEtypefunction(name: string) {
    return this.emailtypeList.filter(item =>
      item.type.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  sendtypeControll() {
    this.sendtype = new FormControl();
    this.filteredSendtypeArray = this.sendtype.valueChanges
      .pipe(startWith(''), map(sendtype => sendtype ? this.filterStypefunction(sendtype) : this.sendtypeList.slice())
      );
  }

  filterStypefunction(name: string) {
    return this.sendtypeList.filter(sendtype =>
      sendtype.type.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  temptypeControll() {
    this.temptype = new FormControl();
    this.filteredtemptypeArray = this.temptype.valueChanges
      .pipe(startWith(''), map(item => item ? this.filtertemptypefunction(item) : this.temptypeList.slice())
      );
  }

  filtertemptypefunction(name: string) {
    return this.temptypeList.filter(item =>
      item.type.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  emailObj(event) {
    this.emailForm.controls.emailType = event.option;
    this.emailTypeName = event.option.value;
    let selecttype = this.emailData.filter(item => item.emailType == event.option.value);
    if (selecttype.length != 0) {
      this.emailTypeName = '';
      this.sendTypeName = '';
      this.updateEmailForm(selecttype[0].pK_TranId);
    } else {
      this.loadEmailConfigForm();
      this.selectfile = '';
      this.selectedfileName = '';
      this.browsebtn = true;
      this.templateTypelist();
      this.MsgeTemp = '';
      this.typename = '';
      this.sendTypeName = '';
    }
  }
  sendObj(event) {
    this.emailForm.controls.sendingType = event.option;
  }

  fileChanged(e) {
    let fileReader = new FileReader();
    this.file = e.target.files[0];
    this.selectedfileName = this.file.name;
    let filetype = this.selectedfileName.split('.');
    let fileTypeCheck = '.' + filetype[1];
    if (this.fileType == fileTypeCheck) {
      fileReader.readAsText(this.file);
      fileReader.onload = (e) => {
        this.selectfile = fileReader.result;
        this.MsgeTemp = this.selectfile;
      }
    } else {
      this.configService.openSnackBar('Please Select File Type', 'OK');
      return;
    }
  }

  tempObj(event) {
    this.tempTypeName = event.option;
    this.selectedfileName = '';
    this.MsgeTemp = '';
    if (event.option.value == 'TextFile') {
      this.browsebtn = false;
      this.fileType = '.txt';
    } else if (event.option.value == 'HTML') {
      this.browsebtn = false;
      this.fileType = '.html'
    } else {
      this.browsebtn = true;
    }
  }

  loadEmailConfigForm() {
    this.emailForm = this._fb.group({
      emailBCC: '',
      emailCC: '',
      emailType: ['', [Validators.required]],
      fileName: '',
      fromMailName: '',
      frommailid: ['', [Validators.required]],
      isActive: false,
      messageTemplate: '',
      otp: '',
      pK_TranId: ' ',
      password: ['', [Validators.required]],
      port: ['', [Validators.required]],
      reqssl: 0,
      sendingType: ['', [Validators.required]],
      smtpid: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      templateType: '',
      toEmail: '',
      username: ['', [Validators.required]]
    });
  }

  clearForm() {
    this.loadEmailConfigForm();
    this.selectfile = '';
    this.selectedfileName = '';
    this.browsebtn = true;
    this.templateTypelist();
    this.emailTypelist();
    this.MsgeTemp = '';
    this.typename = '';
    this.emailTypeName = '';
    this.sendTypeName = '';
  }

  /** Search Email Config */
  searchEmailConfig() {
    const dialogRef = this.dialog.open(SearchEmailConfigComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "450px",
      width: "60%",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.selectEmailObj = this.configService.selecteEmailData
      if (this.selectEmailObj != null) {
        this.selectedEmailId = this.selectEmailObj.pK_TranId;
        this.updateEmailForm(this.selectedEmailId);
      }
    });
  }
  
  emailtypeValidate() {
    if (!this.emailTypeName || !this.emailTypeName.trim()) {
       this.user_validated = this.user_validated + " " + "Email Type, " + " \n";
      return;
    }
  
    const isValidEmailType = this.emailtypeList.some(email => email.type === this.emailTypeName);
  
    if (!isValidEmailType) {
      this.user_validated += "Please Select a Valid Email Type\n";
      return;
    } 
  }

  sendTypeValidate() {
    if (!this.sendTypeName || !this.sendTypeName.trim()) {
      this.user_validated = this.user_validated + " " + "Sender Type, " + " \n";
      return;
    }
  
    const isValidSenderType = this.sendtypeList.some(sender => sender.type == this.sendTypeName);
    if (!isValidSenderType) {
      this.user_validated += "Please Select a Valid Sender Type\n";
      return;
    }
  }
  smtpValidate() {
    if (this.emailForm.controls.smtpid.value == "") {
      this.user_validated = this.user_validated + " " + "SMTP, " + " \n";
    }
  }
  portValidate() {
    if (this.emailForm.controls.port.value == "") {
      this.user_validated = this.user_validated + " " + "Port No, " + " \n";
    }
  }
  userValidate() {
    if (this.emailForm.controls.username.value == "") {
      this.user_validated = this.user_validated + " " + "User Name, " + " \n";
    }
  }
  passwordValidate() {
    if (this.emailForm.controls.password.value == "" ||this.emailForm.controls.password.value == null || this.emailForm.controls.password.value == undefined) {
      this.user_validated = this.user_validated + " " + "Password, " + " \n";
    }
  }
  emailValidate() {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.emailForm.controls.frommailid.value == "") {
      this.user_validated = this.user_validated + " " + "From Email, " + " \n";
    } else if(!emailRegex.test(this.emailForm.controls.frommailid.value)){
      this.user_validated = this.user_validated + " " + "Invalid Email Format, " + " \n";
    }
  }

  templatetypeValidate() {
    if (!this.typename || !this.typename.trim()) {
      this.user_validated = this.user_validated + " " + "From Template, " + " \n";
      return;
    }
    const isValidTempType = this.temptypeList.some(temp => temp.type === this.typename);
    if (!isValidTempType) {
      this.user_validated += "Please Select a Valid Template Type\n";
      return;
    }
  }

  emailCCValidate() {
    const emailCC = this.emailForm.controls.emailCC.value;
    // Regular expression for email validation
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailCC || emailCC.trim() === "") {
      this.user_validated = this.user_validated + " " + "To Email CC, " + " \n";
    } else if (!emailRegex.test(emailCC)) {
      this.user_validated = this.user_validated + " " + "Invalid Email CC Format, " + " \n";
    }
  }

  subjectValidate() {
    const subject = this.emailForm.controls.subject.value;
    if (!subject || subject.trim() === "") {
      this.user_validated = this.user_validated + " " + "Subject, " + " \n";
    }
  }

  checkUservalidation() {
    this.emailtypeValidate();
    this.sendTypeValidate();
    this.smtpValidate()
    this.portValidate();
    this.userValidate();
    this.passwordValidate();
    this.emailValidate();
    this.templatetypeValidate();
    // this.emailCCValidate();
    this.subjectValidate();
    if (this.user_validated != "") {
      const newstring = this.user_validated.substring(0, this.user_validated.length - 2);
      this.configService.openSnackBar("Please Check all Mandatory Fields Marked with * " + " " + newstring, "OK");
      this.user_validated = "";
    }
    else {
      this.saveEmailConfig();
    }
  }
  /** Save and Update email config Form */
  saveEmailConfig() {
    const form = this.emailForm.controls;
    if (form.pK_TranId.value == ' ') {
      form.templateType = this.tempTypeName;
    }
    this.SavingPayLoad = {
      emailBCC: form.emailBCC.value,
      emailCC: form.emailCC.value,
      emailType: this.emailTypeName,
      fileName: this.selectedfileName,
      fromMailName: form.fromMailName.value,
      frommailid: form.frommailid.value,
      IsActive: form.isActive.value,
      messageTemplate: this.MsgeTemp,
      otp: form.otp.value,
      pK_TranId: form.pK_TranId.value,
      password: form.password.value=='******'?null:form.password.value,
      port: form.port.value,
      reqssl: form.reqssl.value,
      sendingType: form.sendingType.value,
      smtpid: form.smtpid.value,
      subject: form.subject.value,
      templateType: form.templateType.value,
      toEmail: form.toEmail.value,
      username: form.username.value
    }
    console.log(this.SavingPayLoad ,'called SavingPayLoad')

    if (this.SavingPayLoad.reqssl === true || this.SavingPayLoad.reqssl == '1') {
      this.SavingPayLoad.reqssl = 1;
    } else {
      this.SavingPayLoad.reqssl = 0;
    }
    // return;
    if (form.pK_TranId.value === ' ') {
      delete this.SavingPayLoad.pK_TranId;
      this.configService.addEmailConfig(this.SavingPayLoad).pipe(takeUntil(this.destroyemail$)).subscribe(data => {
        if (data.statusCode == 1) {
          this.emailForm.controls['pK_TranId'].setValue(data.id);
          this.configService.openSnackBar("Email Configuration Created Successfully " + data.id, "OK");
          this.allEmailType();
        }
      },err =>{
        if (err.status == 403) {
          this.configService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.configService.openSnackBar(err.error.message,"OK");
        } else {
          this.configService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.configService.addEmailConfig(this.SavingPayLoad).pipe(takeUntil(this.destroyemail$)).subscribe(data => {
        if (data.statusCode == 1) {
          this.configService.openSnackBar("Email Configuration Updated Successfully", "OK");
        }
      },err =>{
        if (err.status == 403) {
          this.configService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.configService.openSnackBar(err.error.message,"OK");
        } else {
          this.configService.openSnackBar("API Failed", "OK");
        }
      });
    }
  }

  updateEmailForm(emailtype) {
    this.configService.emailConfigType(emailtype).pipe(takeUntil(this.destroyemail$)).subscribe(data => {
      this.selectedEmaildata = data[0];
      this.emailForm.patchValue(
        {
          pK_TranId: this.selectedEmaildata.pK_TranId,
          emailBCC: this.selectedEmaildata.emailBCC,
          emailCC: this.selectedEmaildata.emailCC,
          fileName: this.selectedEmaildata.fileName,
          fromMailName: this.selectedEmaildata.fromMailName,
          frommailid: this.selectedEmaildata.frommailid,
          isActive: this.selectedEmaildata.isActive,
          password: this.selectedEmaildata.password==null ? '******':this.selectedEmaildata.password,
          port: this.selectedEmaildata.port,
          reqssl: this.selectedEmaildata.reqssl,
          smtpid: this.selectedEmaildata.smtpid,
          subject: this.selectedEmaildata.subject,
          toEmail: this.selectedEmaildata.toEmail,
          username: this.selectedEmaildata.username
        });
      this.sendTypeName = this.selectedEmaildata.sendingType;
      this.emailTypeName = this.selectedEmaildata.emailType;
      this.typename = this.selectedEmaildata.templateType;
      this.MsgeTemp = this.selectedEmaildata.messageTemplate;
      this.selectedfileName = this.selectedEmaildata.fileName;
      if (this.selectedEmaildata.templateType == 'HTML') {
        this.fileType = '.html';
        this.browsebtn = false;
      } else if (this.selectedEmaildata.templateType == 'TextFile') {
        this.fileType = '.txt';
        this.browsebtn = false;
      } else {
        this.browsebtn = true;
      }
    });
  }


  ngOnDestroy() {
    this.destroyemail$.next(true);
    this.destroyemail$.unsubscribe();
    this.emailData = null;
    this.emailtypeList = null;
    this.sendtypeList = null;
    this.temptypeList = null;
    this.selectedEmaildata = null;
  }

  msgtemplate(event) {
    this.MsgeTemp = event.target.value;
  }
  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
}
